// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMPageHeader.tsx — PropelMapper web page header.
//
// The top of every web surface: a page title (display scale, Pine-dark) with an
// optional context subline, and a right-aligned slot for actions (sync pills,
// buttons, avatar, edit toggle — passed as children). All --pm-* tokens.

const PMHEAD_CSS = `
.pmhead{box-sizing:border-box;display:flex;align-items:flex-start;gap:18px;margin-bottom:22px;flex-wrap:wrap}
.pmhead-tx{min-width:0}
.pmhead-title{font:var(--pm-display-s);margin:0;letter-spacing:-.01em;color:var(--pm-fg-1)}
.pmhead-sub{font:var(--pm-body-m);color:var(--pm-fg-2);margin:6px 0 0}
.pmhead-actions{margin-left:auto;display:flex;align-items:center;gap:10px;flex-wrap:wrap}
`;

function pmheadEnsureCSS() {
  if (typeof document === "undefined") return;
  if (document.getElementById("pmhead-css")) return;
  const s = document.createElement("style");
  s.id = "pmhead-css";
  s.textContent = PMHEAD_CSS;
  document.head.appendChild(s);
}

export function PMPageHeader({
  title,
  subtitle,
  className = "",
  style = {},
  children,
  ...rest
}) {
  pmheadEnsureCSS();
  return (
    <header className={"pmhead" + (className ? " " + className : "")} style={style} {...rest}>
      <div className="pmhead-tx">
        <h1 className="pmhead-title">{title}</h1>
        {subtitle != null ? <p className="pmhead-sub">{subtitle}</p> : null}
      </div>
      {children != null ? <div className="pmhead-actions">{children}</div> : null}
    </header>
  );
}
